export const Colors = {
	"primary": "#3A8FF6",
	"background": "#222837",
	"secondaryBackground": "#181B22",
	"purple": "#BC48E3",
	"orange": "#DE9323",
	"green": "#00DC8A",
	"lightBlue": "#17E4FF",
	"tooltipOverlay": "#0C1E3433"
}